import React from 'react'

function HeadingBlock(props) {
  return (
    <h1>{props.children}</h1>
  )
}

export default HeadingBlock